import React, { useCallback } from "react";

import useNavigationStore from "../../../stores/navigationStore";
import BootstrapSVG from "../../BootstrapSVG";

export default function CollapseButton() {
  const handleClick = useCallback(() => {
    useNavigationStore.getState().setOpenSidebar(false);
  }, []);
  return (
    <button style={{ width: "22vw" }} onClick={handleClick} type="button" className="btn icon-btn btn-outline-secondary rounded-0 position-fixed bottom-0 left-0">
      <BootstrapSVG iconName="box-arrow-left" />
    </button>
  );
}
